<template>
  <div>
    <a-toolbar class="primary-gradient pl-4">
      <v-icon left dark> mdi-label-variant </v-icon>
      <span class="widget-title">{{
        $t("widget.timeAllocationWidgetTitle")
      }}</span>
      <v-spacer></v-spacer>
      <meeting-filter section="agenda"></meeting-filter>
    </a-toolbar>
    <v-card color="Neutral" class="time-allocation-card overflow-y-auto">
      <v-skeleton-loader
        v-if="isSkeleton"
        type="article, article"
      ></v-skeleton-loader>
      <v-card-text v-else>
        <v-row>
          <v-col cols="12" sm="12" md="12" class="pt-1 pb-0">
            <side-bar-filters @applyFilter="applyFilter" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-row no-gutters>
              <v-col cols="12" sm="12" md="4">
                <topic-count-chart
                  :chartData="chartData"
                  title="Total Scheduled Time By Agenda Category"
                />
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <actual-vs-schedule-time-chart
                  :chartData="chartData"
                  title="Total Scheduled Time Vs Actual Time By Agenda Category"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <topic-count-chart
                  :chartData="chartData"
                  props="topicCategory"
                  title="Total Scheduled Time By Topic Category"
                />
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <actual-vs-schedule-time-chart
                  :chartData="chartData"
                  props="topicCategory"
                  title="Total Scheduled Time Vs Actual Time By Topic Category"
                />
              </v-col>
            </v-row>
            <v-row v-if="false" no-gutters>
              <actual-vs-schedule-time-chart
                :chartData="chartData"
                props="topicName"
                title="Total Scheduled Time Vs Actual Time By Topic"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SideBarFilters from "./filters/SideBarFilters.vue";
import _ from "lodash";
import ActualVsScheduleTimeChart from "./charts/ActualVsScheduleTimeChart.vue";
import TopicCountChart from "./charts/TopicCountChart.vue";
import SignalRMixin from "@/mixin/SignalRMixin";
import MeetingFilter from "@/components/agenda/MeetingFilter.vue";
import AToolbar from "../../../wrapper-component/AToolbar.vue";
export default {
  name: "TimeAllocationWidget",
  components: {
    SideBarFilters,
    ActualVsScheduleTimeChart,
    TopicCountChart,
    MeetingFilter,
    AToolbar,
  },
  data() {
    return {
      chartData: [],
      meetingsListData: [],
      topicCategories: [],
      isSkeleton: true,
      meetingsList: [],
    };
  },
  mixins: [SignalRMixin],
  computed: {
    ...mapState({
      agendaList: (state) => state.agenda.agendaList,
      // meetingsList: (state) => state.meeting.meetingsList,
      meetingDetails: (state) => state.meeting.meetingDetails,
      durationFilter: (state) => state.agenda.durationFilter,
    }),
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    filteredMeeting() {
      return this.meetingsList;
    },
    ...gettersMap(),
  },
  watch: {
    filteredMeeting() {
      const data = this.filteredMeeting
        .filter((f) => {
          return f.topics.length;
        })
        .map((type) => {
          return {
            meetingName: type.meetingName,
            meetingType: type.meetingType,
            topics: type.topics,
          };
        });
      const arrChartData = [];
      data.forEach((meetingData) => {
        meetingData.topics.forEach((topic) => {
          const agenda = this.agendaList.find((a) => a.id === topic.agendaId);
          if (agenda) {
            const topicCategoryData = this.topicCategories.find(
              (tc) => tc.id === topic.topicCategory
            );
            if (topicCategoryData) {
              const chartObj = {
                meetingName: meetingData.meetingName,
                meetingType: meetingData.meetingType,
                agendaName: agenda.agendaName,
                agendaCategory: agenda.category,
                topicName: topic.topicName,
                topicCategory: topicCategoryData.name,
                scheduleTime: topic.timeInMinutes
                  ? Number(topic.timeInMinutes).toFixed(2)
                  : 0,
                actualTime: topic.elapsed
                  ? Number(topic.elapsed).toFixed(2)
                  : 0,
              };
              arrChartData.push(chartObj);
            }
          }
        });
      });
      this.chartData = arrChartData;
      this.meetingsListData = [...arrChartData];
    },
    async durationFilter() {
      await this.getMeetingsList();
    },
  },
  async created() {
    await this.getAgendaListApi();
    this.setAgendaDurationFilterApi();
    this.topicCategories = this.tenantSettingTypes("topiccategory").sort(
      (a, b) => a.order - b.order
    );
    this.isSkeleton = false;
  },
  mounted() {
    setTimeout(() => {
      const childCard = document.getElementsByClassName("time-allocation-card");
      if (childCard.length > 0) {
        const height = childCard[0].parentElement.parentElement.offsetHeight;
        if (height) {
          childCard[0].style.height = `${height - 48}px`;
        }
      }
    }, 500);
    this.signalRInit(`meeting_${this.selectedTenant}`);
  },
  methods: {
    ...mapActions({
      getAgendaListApi: "agenda/getAgendaList",
      getAgendaMeetingListApi: "meeting/getAgendaMeetingList",
      setAgendaDurationFilterApi: "agenda/setAgendaDurationFilter",
    }),
    signalRInit(target) {
      this.signalConnection.on(target, async (message) => {
        if (message) {
          try {
            await this.getMeetingsList();
          } catch (error) {
            console.log(error, "API error");
          }
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
    applyFilter(filters) {
      const { selectedCategory, selectedMeetingTypes, selectedTopicCategory } =
        filters;
      if (
        selectedCategory.length ||
        selectedMeetingTypes.length ||
        selectedTopicCategory.length
      ) {
        // this.chartData = this.meetingsListData.filter(
        //   (f) =>
        //     selectedCategory.includes(f.agendaCategory) ||
        //     selectedMeetingTypes.includes(f.meetingType) ||
        //     selectedTopicCategory.includes(f.topicCategory)
        // );
        const filterObj = {
          agendaCategory: [...selectedCategory],
          meetingType: [...selectedMeetingTypes],
          topicCategory: [...selectedTopicCategory],
        };
        const cleanObject = _.omitBy(filterObj, (v) =>
          _.isBoolean(v) || _.isFinite(v) ? false : _.isEmpty(v)
        );

        const applyFilter = (data, filter) =>
          data.filter((obj) =>
            Object.entries(filter).every(([prop, find]) => {
              return find.includes(obj[prop]);
            })
          );

        this.chartData = applyFilter(this.meetingsListData, cleanObject);
      } else {
        this.chartData = this.meetingsListData;
      }
    },
    async getMeetingsList() {
      this.meetingsList = await this.getAgendaMeetingListApi(
        this.durationFilter
      );
    },
  },
};

function gettersMap() {
  return mapGetters({
    tenantSettingTypes: "tenant/tenantSettingTypes",
    getAgendaFilterData: "agenda/getFilterData",
  });
}
// this.meetingsList.filter((f) => { return f.topics.length && f.status === 'Started' })

// this.meetingsList.filter((f) => { return f.topics.length}).map((type) => {
//         return {
//           meetingName: type.meetingName, meetingType: type.meetingType, topics: type.topics
//         };
//       })
</script>

<style>
</style>